import { render, staticRenderFns } from "./45zhongdaochanwu.vue?vue&type=template&id=1b4b1fd4&"
import script from "./45zhongdaochanwu.vue?vue&type=script&lang=js&"
export * from "./45zhongdaochanwu.vue?vue&type=script&lang=js&"
import style0 from "./45zhongdaochanwu.vue?vue&type=style&index=0&id=1b4b1fd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports